export const colors = {
    bg: '#f4f4f4',
    black: '#000000',
    brown: '#312b29',
    'light-brown': '#3a322f',
    white: '#ffffff',
    grey: '#8c8c8c',
    textLight: 'rgba(0,0,0,.55)',
    whiteLight: 'rgba(255,255,255,.5)',
    'light-grey': '#f0f0f0',
    'light-grey2': '#f8f8f8',
    lightGrey3: '#e2e2e2',
    yelow: '#eb8f4c',
    miniRed: '#E12F3E',
    orange: '#DC7831',
    pink: '#F0BA93',
    red: '#cb1515',
    red2: '#ef2020',
    redLight: '#ff0000',
    green: '#6be664',
    green2: '#7ebe68',
    green3: '#16840d',
    drawerOverlay: 'rgba(49,43,41,0.8)',
    transparent: 'transparent',
    blue: '#657BFF',
    golden: '#FEE400',
    lightGreen: '#65FB00',
    violet: '#9108FF',
    lightRed: '#FF3566',
    turquoise: '#65EDFF',
    border: '#dee2e6',
};
